<template>
    <section class="content">
        <div class="card">
            <div class="card-header">
                Filter Pencarian
            </div>
                <!-- <div class="p-5"></div> -->
            <div class="card-body row">
                <div class="col-md-6 form-group">
                    <label class="control-label">Tanggal</label>
                    <datepicker
                      placeholder="Tanggal"
                      class="datep"
                      v-model="form.f_tanggal"
                      :options="{format:'yyyy-mm-dd', autoclose: true}" 
                      :autoclose=true
                      required
                    />
                </div>
                <!-- <div class="col-md-6 form-group">
                    <label class="control-label">Unit</label>
                    <v-select :options="optUnit" v-model="form.unit_id" :reduce="opt => opt.id" />
                </div> -->
            </div>
            <div class="card-footer">
                <button type="submit" v-on:click="search" class="btn btn-primary btn-md float-right">Cari</button>
            </div>
        </div>

        <table class="table table-hover" ref="tableuser">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>NAMA STAFF</th>
                        <th>NO. KTP</th>
                        <th>KEHADIRAN</th>
                    </tr>
                </thead>
                <tbody @click="handleClick">
                </tbody>
        </table>
    </section>
</template>
<script>
import { createTable, authFetch } from '@/libs/hxcore';
import $ from 'jquery';
import datepicker from '@/components/Datepicker';
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
import moment from "moment";

export default {
    name: 'AbsensiStaff',
    components: {
        vSelect,
        datepicker,
    },
    data() {
        return {
            errors: [],
            // optUnit: [],
            roles: '',
            form: {
                name: '',
                f_tanggal: '',
                // unit_id: '',
                absen: '',
            },
            tgl: '',
            // unit: '',
        }
    },
    created: function() {
        // this.roles = this.$route.meta.roles;
        // console.log('load initial data', this.$route)

        this.form.f_tanggal = moment().format("YYYY-MM-DD");

        // authFetch('/akademik/absensi_staff/unit')
        //     .then(res => {
        //         if (res.status === 201) {

        //         } else if (res.status === 400) {}
        //         return res.json();
        //     })
        //     .then(js => {
        //         this.optUnit = js.data;
        // });
    },
    methods: {
        handleClick(e) {
            if (e.target.matches('input#masuk')) {
                //masuk
                this.suffleOption(
                    e.target.getAttribute('value'),
                    e.target.getAttribute('id'),
                    e.target.checked ? 1 : 0,
                    1,
                    this.form.f_tanggal,
                    // this.form.unit_id
                    );
            }
            if (e.target.matches('input#sakit')) {
                //sakit
                this.suffleOption(
                    e.target.getAttribute('value'),
                    e.target.getAttribute('id'),
                    e.target.checked ? 1 : 0,
                    2,
                    this.form.f_tanggal,
                    // this.form.unit_id
                    );
            }
            if (e.target.matches('input#ijin')) {
                //ijin
                this.suffleOption(
                    e.target.getAttribute('value'),
                    e.target.getAttribute('id'),
                    e.target.checked ? 1 : 0,
                    3,
                    this.form.f_tanggal,
                    // this.form.unit_id
                    );
            }
            if (e.target.matches('input#alpha')) {
                //alpha
                this.suffleOption(
                    e.target.getAttribute('value'),
                    e.target.getAttribute('id'),
                    e.target.checked ? 1 : 0,
                    4,
                    this.form.f_tanggal,
                    // this.form.unit_id
                    );
            }
        },
        search: function() {
            let self = this;
            self.tgl = self.form.f_tanggal;
            // self.unit = self.form.unit_id;
            this.table.api().ajax.reload();
        },
        suffleOption(id, key, action, push_type, tgl, unt) {
            var urlSubmit = '/akademik/absensi_staff/absen';
            var datas = {
                        action: action,
                        key: key,
                        staff_id: id,
                        push_type: push_type,
                        tgl: tgl,
                        // unit_id: unt
                    };
            var data = Object.keys(datas).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(datas[key])).join('&')

            authFetch(urlSubmit, {
                    method: 'POST',
                    body: data
                })
                .then(res => {
                    if (res.status === 201) {

                    } else if (res.status === 400) {}
                    return res.json();
                })
                .then(js => {

                    this.errors = [];
                    if (!js.success) {
                        console.log(js.details)

                        for (var key in js.details) {
                            if (js.details.hasOwnProperty(key)) {
                                this.errors.push(js.details[key])
                            }
                        }

                        return;
                    }
                    // this.table.api().ajax.reload(null, false);
                    this.table.api().ajax.reload();
                });
        },
    },
    mounted() {
        console.log('load initial data', this.$route.params.roles);
        const e = this.$refs;
        var self = this;

        this.table = createTable(e.tableuser, {
            title: "",
            roles: ["read"],
            ajax: "/akademik/absensi_staff",
            columns: [
                { data: "id",
                visible: false, },
                { data: "name" },
                { data: "no_ktp" },
                { data: "opt",
                sortable: false},
            ],
            filterBy: [1, 2],
            filter: true,
            rowCallback: function(row, data) {},
            paramData: function ( d ) {
                d.tgl = self.tgl;
                // d.unit_id = self.unit;
            },
        });
    }
}
</script>